export default __webpack_public_path__ + "static/Concept_3-f1e9c3d564f49440d4432e0e3dfdbd70.jpg";